import styled from 'styled-components';

export const PageWrapper = styled.div`
  background-color: #ebebeb;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoginWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;

  background-color: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

export const InputSeparator = styled.div`
  width: 100%;
  height: 10px;
`;
